module.exports = __webpack_public_path__ + "img/pharmonia-logo.0bd42f34.svg";